/* unplugin-vue-components disabled */import { render } from "./itemli.vue?vue&type=template&id=0b532f2b&scoped=true"
import script from "./itemli.vue?vue&type=script&lang=js"
export * from "./itemli.vue?vue&type=script&lang=js"

import "./itemli.vue?vue&type=style&index=0&id=0b532f2b&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b532f2b"]])

export default __exports__